import React from 'react';
import { MODULES } from '../../../common/constants';
import PageHeader from '../../../components/PageHeader';
import CommonAudioForm from './CommonAudioForm';

const AddEditAudio = () => {
  return (
    <>
      <PageHeader menu={MODULES?.ASSETS} />
      <div className="page-wrapper">
        <div className="page-wrapper-body">
          <CommonAudioForm />
        </div>
      </div>
    </>
  );
};

export default AddEditAudio;
